@if(field){
<div [formGroup]="form" class="field-container">
  <label class="field-label">{{field['displayName']|camelCase}}</label>
  <mat-form-field class="dynamic-mat-form-field  mat-checkbox-list-container" appearance="outline">
    <mat-select [value]="field.selectedValue" [formControlName]="field['fieldName']" style="visibility: hidden;"         
            hideSingleSelectionIndicator>
    </mat-select>
    @if(form.get(field['fieldName'])?.hasError('required')){
    <mat-error>The {{field.displayName | camelCase}} field is required.</mat-error>
    }
    <mat-selection-list matInput [formControlName]="field['fieldName']" (selectionChange)="onSelectionListChange(field['fieldName'], $event)" multiple [ngClass]="{'dynamic-input-select-disabled':field['disabled']}">
      <mat-list-option *ngFor="let option of field.options" [value]="option['fieldValue']" [title]="option['fieldLabel']">
        {{ option['fieldLabel'] }}
      </mat-list-option>
    </mat-selection-list>
  </mat-form-field>
</div>

}